import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { LocalStorageService } from '../services/local-storage.service';

export const authGuard: CanActivateFn = route => {
  return getProfile();
};

export const authGuardChild: CanActivateChildFn = () => {
  return getProfile();
};

async function getProfile() {
  const _router = inject(Router);
  const local_Service = inject(LocalStorageService);
  const token = local_Service.getItem('token');

  if (!token) {
    _router.navigateByUrl('/auth');
    return false;
  }

  return true;
}
